function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.00078,
  cy: 8.00024,
  r: 7.2,
  fill: "#D3D9E7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6183 10.2157L8.40292 8.00033L10.6183 5.78497C10.6717 5.73156 10.7017 5.65911 10.7017 5.58357C10.7017 5.50804 10.6717 5.43559 10.6183 5.38218C10.5649 5.32876 10.4924 5.29876 10.4169 5.29876C10.3413 5.29876 10.2689 5.32876 10.2155 5.38218L8.00013 7.59753L5.78478 5.38218C5.73136 5.32876 5.65892 5.29876 5.58338 5.29876C5.50784 5.29876 5.4354 5.32876 5.38198 5.38218C5.35482 5.40736 5.33336 5.43807 5.31906 5.47224C5.30477 5.50642 5.29796 5.54326 5.29911 5.58028C5.30025 5.61731 5.30932 5.65366 5.3257 5.68688C5.34208 5.72011 5.36539 5.74943 5.39407 5.77289L7.60942 7.98824L5.38198 10.2157C5.32857 10.2691 5.29856 10.3415 5.29856 10.4171C5.29856 10.4926 5.32857 10.5651 5.38198 10.6185C5.4354 10.6719 5.50784 10.7019 5.58338 10.7019C5.65892 10.7019 5.73136 10.6719 5.78477 10.6185L8.00013 8.40312L10.2155 10.6185C10.2689 10.6719 10.3413 10.7019 10.4169 10.7019C10.4924 10.7019 10.5649 10.6719 10.6183 10.6185C10.6717 10.5651 10.7017 10.4926 10.7017 10.4171C10.7017 10.3415 10.6717 10.2691 10.6183 10.2157Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.5
});

function SvgCloseXicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXicon);
export default __webpack_public_path__ + "static/media/close-x.icon.dfb583da.svg";
export { ForwardRef as ReactComponent };